<template>
	<MainPanel />
</template>

<script>
import MainPanel from '@/components/MainPanel.vue'

export default {
	name: 'HomePage',
	components: {
		MainPanel
	}
}
</script>
